/** @jsxImportSource @emotion/react */
// see - https://www.figma.com/design/9D4Ao5j9kbxunNKph0WR96/Config-Viewer---AntBlocks-1.7?node-id=21390-61578&t=jm0IZJkJGYw6Zwnj-4
import type { PropsWithChildren } from 'react';
import React from 'react';
import type { AriaButtonProps } from 'react-aria';
import { Button as AntdButton } from 'antd';
import type { IButtonProps } from './button-style-helper';
import { useGetButtonVisualProps } from './button-style-helper';
import {
  ELEMENT_ID_DATA_LOG_ATTRIBUTE,
  ELEMENT_ID_DATA_TEST_ATTRIBUTE,
} from '../../../constants/data-element-tracking-ids';

export const Button: React.FC<
PropsWithChildren<
IButtonProps &
Omit<
AriaButtonProps<'button'>,
'onClick' | 'onPress' | 'isDisabled' | 'style'
>
>
> = ({
  children,
  variant,
  isDisabled,
  loading,
  additionalStyles = {},
  themeToken,
  color,
  inlineButton,
  hideDecorations,

  type,
  dataElementId,
  ...props
}) => {
  const {
    styles,
    type: visualType,
    disabled,
    ...visualProps
  } = useGetButtonVisualProps({
    variant,
    themeToken,
    isDisabled,
    loading,
    color,
    inlineButton,
    hideDecorations,
  });
  const uncontrolledProps = { color: undefined, ...props };

  return (
    <AntdButton
      css={[styles, additionalStyles]}
      type={visualType}
      htmlType={type}
      disabled={disabled}
      loading={loading}
      // JSX hack to specify a data-attribute whose name is in a variable:
      {...{
        [ELEMENT_ID_DATA_LOG_ATTRIBUTE]: dataElementId,
        [ELEMENT_ID_DATA_TEST_ATTRIBUTE]: dataElementId,
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...visualProps}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...uncontrolledProps}
    >
      {children}
    </AntdButton>
  );
};
